import { NormalText } from "@/styles/partials/texts";
import globals from "../partials/global-variables";

const questionHeadingSliderFontSize = {
  $lg: globals.fontSize.md,
  $xs: globals.fontSize.lg
};

export default {
  container: {
    "& > p": {
      ...NormalText,
      textAlign: "center",
      width: "100%",
      fontSize: questionHeadingSliderFontSize.$lg,
      margin: [0, 0, "70px"],
      [`@media (${globals.breakpoints.$xs})`]: {
        margin: ["15px", 0, "30px"],
        fontSize: questionHeadingSliderFontSize.$xs
      }
    },
    "& .slider-box": {
      margin: "50px 0",
      padding: ["5px", "50px", "8px"],
      width: "100%",
      backgroundColor: "#fff",
      [`@media (${globals.breakpoints.$xs})`]: {
        margin: [0, 0, "60px", 0],
        padding: ["5px", "15px", "8px"]
      }
    },
    "& .slider-value": {
      ...NormalText,
      margin: "15px 0 5px",
      textAlign: "center"
    },
    "& .slider": {
      background: globals.colors.blue,
      "& .slider-dot": {
        backgroundColor: globals.colors.blue,
        borderRadius: "50%",
        position: "relative"
      }
    },
    "& .slider-selected-range": {
      background: globals.colors.blue
    },
    "& .slider-footer": {
      margin: "10px",
      "&::before": {
        content: "''",
        display: "table"
      },
      "&::after": {
        content: "''",
        display: "table",
        clear: "both"
      },
      "& .slider-min": {
        ...NormalText,
        float: "left"
      },
      "& .slider-max": {
        ...NormalText,
        float: "right"
      }
    }
  }
};
